define('controllers/recoverpassword',['require'],function(require) {
	return function() {		
		$(function () {
			var msg = $("#msg"),
			Email = $("#Email"),
			UserName = $("#UserName"),
			answer = $("#answer"),
			findUser = $("#findUser"),
			GetUser = $("#GetUser"),
			SubmitAnswer = $("#SubmitAnswer"),
			SubmitButton = $("#SubmitButton");

			function setError(text) {
				msg.addClass("alert-error").removeClass("alert-info").show().html(text);
			}
			function setInfo(text) {
				msg.addClass("alert-info").removeClass("alert-error").show().html(text);
			}

			//find user...
			GetUser.on("click", function () {
				var $this = $(this),
				Loading = $this.next(),
				UserNameVal = UserName.val().trim(),
				EmailVal = Email.val().trim();

				msg.hide();

				if (UserNameVal != "" || EmailVal != "") {
					$this.hide();
					Loading.show();

					$.ajax({
						type: 'POST',
						url: "RecoverPasswordAJAX.aspx",
						data: { UserName: UserNameVal, Email: EmailVal },
						success: function (response) {
							response = JSON.parse(response);
							if (response.question != undefined && response.question.trim() != "") {
								//set up question answer portion
								$("#question").text(response.question);
								findUser.hide();
								SubmitAnswer.fadeIn('fast', function() {
									answer.focus();
								});
							} else if (response.info.trim() !== '') {
								setInfo(response.info);
								$this.show();
								Loading.hide();
							} else if (response.error.trim() !== '') {
								setError(response.error);
								$this.show();
								Loading.hide();
							} else {
								setError("Something went wrong. Please re-load the page and try again or contact Adestinn Support. [qst]");
								$this.show();
								Loading.hide();
							}
						},
						error: function () {
							setError("Something went wrong. Please re-load the page and try again or contact Adestinn Support. [qst2]");
							$this.show();
							Loading.hide();
						}
					});
				} else {
					setError("Please enter either an email or username to recover your password.");
				}
			});

			//submit answer...
			SubmitButton.on("click", function () {
				var $this = $(this),
				Loading = $this.next(),
				UserNameVal = UserName.val().trim(),
				EmailVal = Email.val().trim(),
				AnswerVal = $("#answer").val().trim();

				msg.hide();

				if (AnswerVal != "") {
					$this.hide();
					Loading.show();

					$.ajax({
						type: 'POST',
						url: "RecoverPasswordAJAX.aspx",
						data: { UserName: UserNameVal, Email: EmailVal, Answer: AnswerVal },
						success: function (response) {
							response = JSON.parse(response);
							if (response.error != undefined && response.error != "") {
								setError(response.error);
								$this.show();
								Loading.hide();
							} else if (response.info != undefined && response.info != "") {
								setInfo(response.info);
								SubmitAnswer.hide();
							} else {
								setError("Something went wrong. Please re-load the page and try again or contact Adestinn Support. [Ans]");
								$this.show();
								Loading.hide();
							}
						},
						error: function () {
							setError("Something went wrong. Please re-load the page and try again or contact Adestinn Support. [Ans2]");
							$this.show();
							Loading.hide();
						}
					});
				} else {
					setError("Please enter your answer.");
				}
			});

			Utilities.setDefaultButton(findUser, GetUser);
			Utilities.setDefaultButton(SubmitAnswer, SubmitButton);
			UserName.focus();
		});
	};
});
